// src/utils/firmaSalvata.js
// ═══════════════════════════════════════════════════════════════════════════
// LA MIA FIRMA (ottobre 2026)
// ═══════════════════════════════════════════════════════════════════════════
// Il tecnico salva una volta la propria firma e la mette con un tocco come «firma del
// tecnico» su rapportini, interventi di manutenzione e giornale di cantiere, invece di
// rifirmare col dito ogni volta. La firma del CLIENTE si raccoglie sempre sul momento.
// Dove sta: firmeUtenti/{uid}, un documento che può leggere e scrivere SOLO il diretto
// interessato (regole Firestore 60): i colleghi non la vedono e non possono usarla.
// ═══════════════════════════════════════════════════════════════════════════
import { useEffect, useState } from "react";
import { doc, onSnapshot, setDoc, deleteDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "../contexts/AuthContext";

/** { firma (PNG dataURL o null), caricata, salva(dataUrl), elimina() } dell'utente collegato. */
export function useMiaFirma() {
  const { currentUser } = useAuth();
  const uid = currentUser?.uid;
  const [stato, setStato] = useState({ firma: null, caricata: false });
  useEffect(() => {
    if (!uid) { setStato({ firma: null, caricata: true }); return undefined; }
    return onSnapshot(doc(db, "firmeUtenti", uid),
      s => setStato({ firma: (s.exists() && s.data()?.firma) || null, caricata: true }),
      () => setStato({ firma: null, caricata: true }));
  }, [uid]);
  const salva = async (firma) => {
    if (!uid || !firma) return;
    await setDoc(doc(db, "firmeUtenti", uid), { firma, aggiornataIl: serverTimestamp() });
  };
  const elimina = async () => { if (uid) await deleteDoc(doc(db, "firmeUtenti", uid)); };
  return { ...stato, salva, elimina };
}
